import * as Types from '../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import { ConfirmIntegrationActionModalIntegrationFragmentDoc } from '../modals/generated/confirm';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetIntegrationsQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  integrationType: Types.IntegrationType;
}>;


export type GetIntegrationsQuery = { __typename?: 'Query', integrationConfigurations?: { __typename?: 'IntegrationConfigurationsConnection', nodes: Array<{ __typename?: 'IntegrationConfiguration', id: string, integrationType: Types.IntegrationType, name: string, configuration: unknown, created: string, environmentId: string, enabled?: boolean | null, associatedActionFlows: Array<{ __typename?: 'ActionFlowIntegrationSummary', id: string, name?: string | null, usedInPublishedVersion: boolean }> }> } | null };

export type UpdateIntegrationMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  id: Types.Scalars['String']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  configuration?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', updateIntegrationConfiguration?: { __typename?: 'UpdateIntegrationConfigurationPayload', integrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string, integrationType: Types.IntegrationType, name: string, configuration: unknown, created: string, environmentId: string, enabled?: boolean | null, associatedActionFlows: Array<{ __typename?: 'ActionFlowIntegrationSummary', id: string, name?: string | null, usedInPublishedVersion: boolean }> } | null } | null };

export type AddIntegrationMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  configuration: Types.Scalars['JSON']['input'];
  integrationType: Types.IntegrationType;
}>;


export type AddIntegrationMutation = { __typename?: 'Mutation', createIntegrationConfiguration?: { __typename?: 'CreateIntegrationConfigurationPayload', integrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string, integrationType: Types.IntegrationType, name: string, configuration: unknown, created: string, environmentId: string, enabled?: boolean | null, associatedActionFlows: Array<{ __typename?: 'ActionFlowIntegrationSummary', id: string, name?: string | null, usedInPublishedVersion: boolean }> } | null } | null };

export type DeleteIntegrationMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  id: Types.Scalars['String']['input'];
}>;


export type DeleteIntegrationMutation = { __typename?: 'Mutation', deleteIntegrationConfiguration?: { __typename?: 'DeleteIntegrationConfigurationPayload', integrationConfiguration?: { __typename?: 'IntegrationConfiguration', id: string } | null } | null };

export type IntegrationDetailFragment = { __typename?: 'IntegrationConfiguration', id: string, integrationType: Types.IntegrationType, name: string, configuration: unknown, created: string, environmentId: string, enabled?: boolean | null, associatedActionFlows: Array<{ __typename?: 'ActionFlowIntegrationSummary', id: string, name?: string | null, usedInPublishedVersion: boolean }> };

export const IntegrationDetailFragmentDoc = gql`
    fragment IntegrationDetail on IntegrationConfiguration {
  id
  integrationType
  name
  configuration
  created
  environmentId
  enabled
  ...ConfirmIntegrationActionModalIntegration
}
    ${ConfirmIntegrationActionModalIntegrationFragmentDoc}`;
export const GetIntegrationsDocument = gql`
    query GetIntegrations($environmentId: String!, $integrationType: IntegrationType!) {
  integrationConfigurations(
    condition: {environmentId: $environmentId, integrationType: $integrationType}
  ) {
    nodes {
      ...IntegrationDetail
    }
  }
}
    ${IntegrationDetailFragmentDoc}`;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables> & ({ variables: GetIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const UpdateIntegrationDocument = gql`
    mutation UpdateIntegration($environmentId: String!, $id: String!, $name: String, $configuration: JSON, $enabled: Boolean) {
  updateIntegrationConfiguration(
    input: {environmentId: $environmentId, id: $id, patch: {name: $name, configuration: $configuration, enabled: $enabled}}
  ) {
    integrationConfiguration {
      ...IntegrationDetail
    }
  }
}
    ${IntegrationDetailFragmentDoc}`;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      configuration: // value for 'configuration'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(UpdateIntegrationDocument, options);
      }
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;
export const AddIntegrationDocument = gql`
    mutation AddIntegration($environmentId: String!, $name: String!, $configuration: JSON!, $integrationType: IntegrationType!) {
  createIntegrationConfiguration(
    input: {integrationConfiguration: {environmentId: $environmentId, name: $name, configuration: $configuration, enabled: true, integrationType: $integrationType}}
  ) {
    integrationConfiguration {
      ...IntegrationDetail
    }
  }
}
    ${IntegrationDetailFragmentDoc}`;

/**
 * __useAddIntegrationMutation__
 *
 * To run a mutation, you first call `useAddIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntegrationMutation, { data, loading, error }] = useAddIntegrationMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      configuration: // value for 'configuration'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useAddIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<AddIntegrationMutation, AddIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIntegrationMutation, AddIntegrationMutationVariables>(AddIntegrationDocument, options);
      }
export type AddIntegrationMutationHookResult = ReturnType<typeof useAddIntegrationMutation>;
export type AddIntegrationMutationResult = Apollo.MutationResult<AddIntegrationMutation>;
export type AddIntegrationMutationOptions = Apollo.BaseMutationOptions<AddIntegrationMutation, AddIntegrationMutationVariables>;
export const DeleteIntegrationDocument = gql`
    mutation DeleteIntegration($environmentId: String!, $id: String!) {
  deleteIntegrationConfiguration(input: {environmentId: $environmentId, id: $id}) {
    integrationConfiguration {
      id
    }
  }
}
    `;

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, options);
      }
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>;
export type DeleteIntegrationMutationResult = Apollo.MutationResult<DeleteIntegrationMutation>;
export type DeleteIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;